import { useMemo } from "react";
import { useColumns as useTeamColumns } from "../../../../../TimeSheet/Team/Table/useColumns";
import { useGroups } from "../../../../General/OrganisationLevelGroups/context";
import { useAllowedColumns } from "../../hooks/useAllowedColumns";
import { toConfig } from "../../helpers";

export const useHiddenColumns = () => {
    const { groups } = useGroups();
    return useMemo(() => [
        "jobs",
        "locations",
        "pb",
        "upto",
        "unpaid",
        ...groups.reduce((total: string[], { allocatedBy, level }: any) => {
            if (!allocatedBy) {
                return total.concat(level.replace("_", ""));
            }
            return total;
        }, []),
    ], [groups]);
};

export const useColumns = () => {
    const columns = useTeamColumns({ canViewRates: true, viewSummary: () => { }, viewProfile: () => { } });
    const allowed = useAllowedColumns(columns);
    return useMemo(() => toConfig(allowed), [allowed]);
};
